import React from "react";

import { Layout, NFTStakingHistory } from "../components";

const NFTStakingHistoryPage = () => {
  return (
    <>
      <Layout>
        <NFTStakingHistory />
      </Layout>
    </>
  );
};

export default NFTStakingHistoryPage;
